/**
 * Tracks compact-mode submissions awaiting their reply frame. Drives the
 * transient "compact-reply" peek when the matching frame is created.
 */
import { create } from "zustand";
import { mirroredStore } from "@/lib/mirrored-store";

type State = {
  pendingSubmittedAt: number | null;
};
type Actions = {
  markPending: () => void;
  clear: () => void;
};

export const useCompactSubmissionStore = create<State & Actions>()(mirroredStore("compactSubmission", (set) => ({
  pendingSubmittedAt: null,
  markPending: () => set({ pendingSubmittedAt: Date.now() }),
  clear: () => set({ pendingSubmittedAt: null }),
})));
